<template>
  <div id="app">
    <div class="pre-loading" v-if="!preLoadingFlag">
      <img
        src="./assets/images/preload_loading.gif"
        style="width: 50%; margin-top: 65%"
        @load="loadComplete"
        @error="loadComplete"
      />
      <p>{{ progressStr }}</p>
    </div>
    <template v-else>
      <div class="logo fadeInDown animated">
        <img class="img-btn" src="./assets/images/logo.png" />
      </div>

      <div class="logo-btn">
        <div class="prev" v-if="isPrev" @click="handlePrev">
          <img src="./assets/images/www.png" style="margin-top: 7px" />
        </div>

        <div class="music">
          <img
            style="margin-top: 2px"
            src="./assets/images/music_start.gif"
            @click="audioPlay(false)"
            v-if="musicStatus"
          />
          <img
            src="./assets/images/music_close.png"
            style="margin-top: 2px"
            @click="audioPlay(true)"
            v-else-if="musicStatus === false"
          />

          <audio loop="loop" id="music">
            <source :src="music" />
          </audio>
        </div>
      </div>

      <transition :name="transitionName">
        <router-view
          v-on:logo="logo"
          v-on:prev="prev"
          v-on:audioPlay="audioPlay"
          ref="my_router"
        />
      </transition>
    </template>
  </div>
</template>

<script>
import { Circle } from "vant";
import preloadImage from "vue-preload-image";
import FastClick from "fastclick";
export default {
  name: "App",
  components: {
    [Circle.name]: Circle,
    preloadImage,
  },
  data() {
    return {
      isLogo: true,
      isPrev: true,
      music: null,
      musicStatus: null,
      preLoadingFlag: false,
      progressStr: "",
      imgUrls: [
        require("./assets/images/people/one_0.png"),
        require("./assets/images/people/one_1.png"),
        require("./assets/images/people/one_2.png"),
        require("./assets/images/people/one_3.png"),
        require("./assets/images/people/one_4.png"),
        require("./assets/images/people/one_5.png"),
        require("./assets/images/people/one_6.png"),
        require("./assets/images/people/two_0.png"),
        require("./assets/images/people/two_1.png"),
        require("./assets/images/people/two_2.png"),
        require("./assets/images/people/two_3.png"),
        require("./assets/images/people/two_4.png"),
        require("./assets/images/people/two_5.png"),
        require("./assets/images/people/two_6.png"),
        require("./assets/images/people/three_0.png"),
        require("./assets/images/people/three_1.png"),
        require("./assets/images/people/three_2.png"),
        require("./assets/images/people/three_3.png"),
        require("./assets/images/people/three_4.png"),
        require("./assets/images/people/three_5.png"),
        require("./assets/images/people/three_6.png"),
        require("./assets/images/start_btn.png"),
        require("./assets/images/perfect_data.png"),
        require("./assets/images/deng/2.png"),
        require("./assets/images/deng/3.png"),
        require("./assets/images/deng/4.png"),
        require("./assets/images/deng/border_one.png"),
        require("./assets/images/deng/border_two.png"),
        require("./assets/images/deng/char.png"),
        require("./assets/images/office_bg.jpg"),
        require("./assets/images/people_video_bg.jpg"),
        require("./assets/images/welcome_bg.jpg"),
        require("./assets/images/hr_bg.jpg"),
        require("./assets/images/bar_bg.jpg"),
        require("./assets/images/video_bg.jpg"),
        require("./assets/images/login_bg.jpg"),
        require("./assets/images/card_bg.jpg"),
        require("./assets/images/city_bg.jpg"),
        require("./assets/images/card1.png"),
        require("./assets/images/card2.png"),
        require("./assets/images/card3.png"),
        require("./assets/images/card4.png"),
        require("./assets/images/card5.png"),
        require("./assets/images/card6.png"),
        require("./assets/images/card7.png"),
        require("./assets/images/card8.png"),
        require("./assets/images/card9.png"),
        require("./assets/images/card10.png"),

        require("./assets/images/city/bj001.png"),
        require("./assets/images/city/bj001-001.jpg"),
        require("./assets/images/city/bj001-002.jpg"),
        require("./assets/images/city/bj002.png"),
        require("./assets/images/city/bj002-001.jpg"),
        require("./assets/images/city/bj002-001.jpg"),
        require("./assets/images/city/sh001.png"),
        require("./assets/images/city/sh001-001.jpg"),
        require("./assets/images/city/sh001-002.jpg"),
        require("./assets/images/city/sh002.png"),
        require("./assets/images/city/sh002-001.jpg"),
        require("./assets/images/city/sh002-002.jpg"),
        require("./assets/images/city/sh002-003.jpg"),
        require("./assets/images/city/sz001.png"),
        require("./assets/images/city/sz001-001.jpg"),
        require("./assets/images/city/sz001-002.jpg"),

        require("./assets/images/door.png"),
        require("./assets/images/group_bg.jpg"),
        require("./assets/images/hr.png"),
        require("./assets/images/loading_top.jpg"),
        require("./assets/images/light_1.png"),
        require("./assets/images/light_2.png"),
        require("./assets/images/light_3.png"),
        require("./assets/images/light_4.png"),
        require("./assets/images/light_5.png"),
        require("./assets/images/light_6.png"),
        require("./assets/images/light_7.png"),
        require("./assets/images/light_8.png"),
        require("./assets/images/light_9.png"),
        require("./assets/images/light_10.png"),
        require("./assets/images/light_11.png"),
        require("./assets/images/light_12.png"),
        require("./assets/images/loading_bottom.jpg"),

        require("./assets/images/one_single.png"),
        require("./assets/images/one_single_select.png"),
        require("./assets/images/two_single.png"),
        require("./assets/images/two_single_select.png"),
        require("./assets/images/three_single.png"),
        require("./assets/images/three_single_select.png"),

        require("./assets/images/msg_2.png"),
        require("./assets/images/msg_3.png"),
        require("./assets/images/msg_5.png"),
        require("./assets/images/msg_6.png"),
        require("./assets/images/msg_7.png"),
        require("./assets/images/msg_9.png"),

        require("./assets/images/select_btn_girl.png"),
        require("./assets/images/my_introduction.png"),

        require("./assets/images/pdf.png"),
      ],
      transitionName: "",
    };
  },
  watch: {
    //使用watch 监听$router的变化
    $route(to, from) {
      if (to.meta.index > from.meta.index) {
        //设置动画名称
        this.transitionName = "slide-left";
      } else {
        this.transitionName = "slide-right";
      }
    },
  },
  methods: {
    logo(flag) {
      this.isLogo = flag;
    },

    prev(flag) {
      this.isPrev = flag;
    },

    handlePrev() {
      if (
        this.$refs.my_router.hasOwnProperty("handlePrev") &&
        "function" === typeof this.$refs.my_router.handlePrev
      ) {
        this.$refs.my_router.handlePrev();
      } else {
        this.$router.go(-1);
      }
    },
    audioPlay(flag) {
      let audio = document.getElementById("music");
      if (flag) {
        audio.play();
        this.musicStatus = true;
      } else {
        audio.pause();
        this.musicStatus = false;
      }
    },
    loadComplete() {
      this.$nextTick(() => {
        this.preLoadSource();
      });
    },
    preLoadSource() {
      let loadedCount = 0;
      let total = this.imgUrls.length;
      let time = new Date().getTime();
      let cb = () => {
        loadedCount++;
        this.progressStr = `${parseInt((loadedCount * 100) / total)}%`;
        if (loadedCount >= total) {
          this.music = require("./assets/audio/MonsieurMelody.mp3");
          this.preLoadingFlag = true;
          const loadDuration = new Date().getTime() - time;
          this.$store.commit("setLoadTime", loadDuration);
          this.$api.doPost("/dataMonitor/savePageLoadSpeed", { loadDuration });
          const { systemInfo } = this.$store.state;
          this.$api.doPost("/dataMonitor/saveNoticeTouchData", {
            number: systemInfo.deviceId,
            type: systemInfo.sourceType,
          });
        }
      };
      this.imgUrls.forEach((img) => {
        let oImg = new Image();
        oImg.addEventListener("load", cb);
        oImg.addEventListener("error", cb);
        oImg.src = img;
      });
    },
  },
  created() {
    //FastClick的ios点击穿透
    FastClick.prototype.focus = function (targetElement) {
      let length;
      if (
        targetElement.setSelectionRange &&
        targetElement.type.indexOf("date") !== 0 &&
        targetElement.type !== "time" &&
        targetElement.type !== "month"
      ) {
        length = targetElement.value.length;
        targetElement.focus();
        targetElement.setSelectionRange(length, length);
      } else {
        targetElement.focus();
      }
    };
    FastClick.attach(document.body);

    this.userInfo = this.$store.state.userInfo;
  },
};
</script>

<style lang="scss">
/**
     * 全局公用样式
     *
     */
@import "./assets/css/animate.min.css";
@import "./assets/css/common.css";

.pre-loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;
  color: #ffffff;
  font-family: "ApercuPro", tahoma, arial, "Hiragino Sans GB", "微软雅黑",
    simsun, sans-serif;
  font-size: 18px;
  font-weight: 500;
  text-align: center;
}

#app {
  height: 100%;
  overflow: hidden;
}

.logo {
  position: fixed;
  top: 3%;
  left: 31%;
  width: 38%;
  z-index: 100;
}

.logo-btn {
  position: fixed;
  top: 3%;
  z-index: 500;
  width: 100%;

  img {
    width: 30px;
  }

  .prev {
    float: left;
    margin-left: 3%;
  }
  .music {
    float: right;
    margin-right: 3%;
  }
}

.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 500ms;
  position: absolute;
}
.slide-right-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
.slide-right-leave-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.slide-left-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.slide-left-leave-active {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
html,
body {
  height: 100%;
  overflow: hidden;
}
</style>
